module.exports = __webpack_public_path__ + "img/YuanAngel.5fe79841.png";